import type { Box } from '../strangler'

// The magic hard cap, recomputed at three duplicated sites (magic.js:69,
// :227, script.js:2245) — the formula stays duplicated until step 5
// canonicalizes it; only the storage is promoted here. Value is a
// break_eternity Decimal created by pristine code, typed opaquely until
// shared/decimal.ts exists (step 5).
export const magicHardcap: Box<unknown> = { value: undefined }
